import * as MutationsType from "./mutationsType";
import { id as configId } from "Config/config";
import requestAxios from "@/helpers/request_axios";
import { roles } from "@/helpers/get_constants";

export default {
  async getBusinessConfig({ rootState, commit }) {
    try {
      let agent = rootState.Agent.agent;
      let response = await requestAxios({
        url: `/awy/api/v1/business/${agent.role === roles.ENTREPRENEUR ? agent.team_id : configId}`,
        method: "GET",
      });
      commit(MutationsType.SET_BUSINESS, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async createBusinessConfig({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/business",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.SET_BUSINESS, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessConfig({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_BUSINESS, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async createBusinessEcommerce({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/ecommerce`,
        method: "POST",
      });
      commit(MutationsType.SET_ECOMMERCE, response.data.data);
      commit(MutationsType.UPDATE_BUSINESS, { ecommerce_url: response.data.data.url });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessEcommerce({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/ecommerce/default`,
        method: "GET",
      });
      commit(MutationsType.SET_ECOMMERCE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessEcommerce({ commit, state }, { ecommerce }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/ecommerce/default`,
        method: "PATCH",
        data: ecommerce,
      });
      commit(MutationsType.SET_ECOMMERCE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessLandingPages({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/landing-pages`,
        method: "GET",
      });
      commit(MutationsType.SET_LANDING_PAGES, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessLandingPage({ commit, state }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/landing-pages/${id}`,
        method: "GET",
      });
      commit(MutationsType.SET_LANDING_PAGE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async createBusinessLandingPage({ commit, state }, { landingPage }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/landing-pages`,
        method: "POST",
        data: landingPage,
      });
      commit(MutationsType.ADD_LANDING_PAGE, response.data.data);
      commit(MutationsType.UPDATE_BUSINESS, { landing_page_url: response.data.data.url });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessLandingPage({ commit, state }, { id, landingPage }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/landing-pages/${id}`,
        method: "PATCH",
        data: landingPage,
      });
      commit(MutationsType.UPDATE_LANDING_PAGE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetBusinessLandingPage({ commit }) {
    commit(MutationsType.SET_LANDING_PAGE, null);
  },
  async saveBusinessEmbedForm({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/embed-forms`,
        method: "POST",
        data: data,
      });

      if (!state.embedForms) commit(MutationsType.SET_EMBED_FORMS, []);

      commit(MutationsType.ADD_EMBED_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessEmbedForms({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/embed-forms`,
        method: "GET",
      });
      commit(MutationsType.SET_EMBED_FORMS, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessEmbedForm({ commit, state }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/embed-forms/${id}`,
        method: "GET",
      });
      commit(MutationsType.SET_EMBED_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessEmbedForm({ commit, state }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/embed-forms/${id}`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_EMBED_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async enableBusinessCustomForm({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/custom-forms`,
        method: "POST",
      });

      if (!state.customForms) commit(MutationsType.SET_CUSTOM_FORMS, []);

      commit(MutationsType.ADD_CUSTOM_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveBusinessCustomForm({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/custom-forms`,
        method: "POST",
        data: data,
      });

      if (!state.customForms) commit(MutationsType.SET_CUSTOM_FORMS, []);

      commit(MutationsType.ADD_CUSTOM_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessCustomForms({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/custom-forms`,
        method: "GET",
      });
      commit(MutationsType.SET_CUSTOM_FORMS, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessCustomForm({ commit, state }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/custom-forms/${id}`,
        method: "GET",
      });
      commit(MutationsType.SET_CUSTOM_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessCustomForm({ commit, state }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/custom-forms/${id}`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_CUSTOM_FORM, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessSpecialFields({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/special-fields`,
        method: "GET",
      });

      commit(MutationsType.SET_SPECIAL_FIELDS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveBusinessSpecialField({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/special-fields`,
        method: "POST",
        data: data,
      });

      if (!state.specialFields) commit(MutationsType.SET_SPECIAL_FIELDS, []);

      commit(MutationsType.ADD_SPECIAL_FIELD, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessSpecialField({ commit, state }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/special-fields/${id}`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_SPECIAL_FIELD, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getBusinessFaq({ commit, state }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/faqs/${id}`,
        method: "GET",
      });

      commit(MutationsType.SET_FAQ, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllBusinessFaqs({ commit, state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/faqs`,
        method: "GET",
      });

      commit(MutationsType.SET_FAQS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveBusinessFaq({ commit, state }, { data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/faqs`,
        method: "POST",
        data: data,
      });

      if (!state.faqs) commit(MutationsType.SET_FAQS, []);

      commit(MutationsType.ADD_FAQ, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateBusinessFaq({ commit, state }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/faqs/${id}`,
        method: "PATCH",
        data: data,
      });

      commit(MutationsType.UPDATE_FAQ, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteBusinessFaq({ commit, state }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/business/${state.business.id}/faqs/${id}`,
        method: "DELETE",
      });

      commit(MutationsType.DELETE_FAQ, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleBusiness({ commit }) {
    commit(MutationsType.SET_BUSINESS, null);
    commit(MutationsType.SET_LANDING_PAGE, null);
    commit(MutationsType.SET_LANDING_PAGES, null);
    commit(MutationsType.SET_ECOMMERCE, null);
    commit(MutationsType.SET_EMBED_FORMS, null);
    commit(MutationsType.SET_FAQS, null);
  },
};
